import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Container } from '../../components/layout/style';
import {getProductDetails,updateProductAuth} from '../../actions/product';
import { Table, Tag, Space, PageHeader, Modal, Button, Input, Row, Col, Select, Tooltip, Descriptions, Card } from 'antd';
import UpdateImage from './updateImage';
import './style.css'
import { CheckCircleFilled,CloseCircleOutlined, WarningOutlined } from '@ant-design/icons';
const ProductDetails =  ({location,getProductDetails,updateProductAuth}) => {
    const [data, setData] = useState([])
    const [isImageModalVisible, setIsImageModalVisible] = useState(false)
    const [isThumbVisible, setisThumbVisible] = useState(false)
    const [id, setId] = useState(false)
    useEffect( async () => {
        window.scrollTo(0, 0);
        const search = location.search;
        const id = new URLSearchParams(search).get("id");
        setId(id)
        const res = await getProductDetails(id);
        setData(res)
    }, [])

    const makeLocalTime = (date) => {
      let mainDate = date.split('T')[0];
      let hours = date.split('T')[1].split(':')[0];
      let minutes = date.split('T')[1].split(':')[1];
      var am = true;
      if (hours > 12) {
          am = false;
          hours -= 12
      } else if (hours == 12) {
          am = false;
      } else if (hours == 0) {
          hours = 12
      }
      return mainDate + " , " + hours+":"+minutes + " " + (am ? "a.m" : "p.m")
    }

    const handleRefresh = async () => {
        const res = await getProductDetails(id);
        setData(res)
    }
    
  const handleStatus = async (status) => {
    const res = await updateProductAuth(id,status)
    if(res === 201){
      handleRefresh()
    }
  }
    return ( 
        <Container  style={{minHeight: '100vh'}}>
        <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Products"
            subTitle="Product details"
            
        >
        </PageHeader>
        <div >
            
            {/* <h2>Product Name : {data?.name}</h2>
            <Tag color="hsla(207.04225352112675, 100%, 13.92156862745098%, 0.863)">{data?.product_id}</Tag>
            {data?.active === 'active' ? <Tag color="#2db7f5">{data?.active}</Tag> : null}
            {data?.active === 'inactive' ? <Tag color="#be3636">{data?.active}</Tag> : null} */}
            {data?.active === 'inactive' ?
                <Button type="ghost" icon={<CheckCircleFilled />} size="small" style={{float: 'right',backgroundColor: '#348a49',color:'#fff'}} onClick={() =>handleStatus('active')}>Activate</Button>
            :
                <Button type="ghost" icon={<WarningOutlined />} size="small" style={{float: 'right',backgroundColor: '#BE3636',color:'#fff'}}  onClick={() =>handleStatus('inactive')}>Disable</Button>
            }
            {/* <Tag color="#cd2df5">{data?.created_at ? makeLocalTime(data?.created_at) : null}</Tag> */}
            <br />
            <br />
       
            <Row className='detailContainer'>
                <Col xs={0} sm={3}></Col>
                <Col xs={24} sm={9} className='big-image-container'>
                    <Row>
                        <Col xs={24}>
                            {data.image ?
                                <img className='big-image' style={{border: '1px solid gray'}} src={`${process.env.REACT_APP_API_BASE_URL}/files/${data.image}`} alt="Product Image" />
                                :
                                <img className='big-image' style={{border: '1px solid gray'}} src="demo.jpg" alt="Product Image" />
                            }
                            </Col>
                        <Col xs={24}>&nbsp;</Col>
                        <Col xs={12}>
                            <p>*Image size 600x600</p>
                        </Col>
                        <Col xs={12}>
                            <Button type="primary" onClick={()=> setIsImageModalVisible(true)}>Change</Button>
                        </Col>
                    </Row>
                </Col>
                <Col xs={24} sm={9}  style={{alignSelf: 'center'}}>
                    <Row>
                        <Col xs={24}>
                            <h1 style={{color: '#ED1C24', fontWeight: '600'}}>{data?.name} <Tag color="hsla(207.04225352112675, 100%, 13.92156862745098%, 0.863)">{data?.product_id}</Tag>
                                {data?.active === 'active' ? <Tag color="#2db7f5">{data?.active}</Tag> : null}
                                {data?.active === 'inactive' ? <Tag color="#be3636">{data?.active}</Tag> : null}
                            
                                <Tag color="#cd2df5">{data?.created_at ? makeLocalTime(data?.created_at) : null}</Tag>
                            </h1>
                            <p  style={{ fontSize: '16px'}}>{data?.description}</p>
                        </Col>
                        <Col xs={24}>
                            <h4 style={{fontWeight: 'bold', fontSize: '16px'}}>Duribility: &nbsp;
                            {data?.life_time === 'expireable' ?
                            <>
                                <Tag type="primary" style={{fontSize: '14px', padding: '5px', fontWeight: 'normal'}}> Expireable</Tag>
                                </> :
                            <>
                                <Tag type="primary" style={{fontSize: '14px', padding: '5px', fontWeight: 'normal'}} > Non Expireable</Tag>
                                </> 
                            }
                            </h4>
                            
                        </Col>
                        <Col xs={24}>&nbsp;</Col>

                        <Col xs={18}>
                            <h4 style={{fontWeight: 'bold', fontSize: '16px'}}>More Information:</h4>
                            <Row gutter={30}>
                                <Col xs={24} sm={12}>
                                    <Card style={{boxShadow: '1px 10px 13px -12px rgba(0,0,0,0.75)', borderRadius: '8px'}}>
                                        <h4 style={{fontWeight: 'bold', fontSize: '16px', borderBottom: '1px solid #c7c2c2'}}>Weight</h4>
                                        <p style={{fontSize: '14px', color: '#000'}}>Weight: <strong>{data?.weight}</strong></p>
                                        <p style={{fontSize: '14px', color: '#000'}}>Weight unit: <strong>{data?.weight_unit}</strong></p>
                                    </Card>
                                </Col>
                                
                                <Col xs={24} sm={0}>&nbsp;</Col>
                                <Col xs={24} sm={12}>
                                    <Card style={{boxShadow: '1px 10px 13px -12px rgba(0,0,0,0.75)', borderRadius: '8px'}}>
                                        <h4 style={{fontWeight: 'bold', fontSize: '16px', borderBottom: '1px solid #c7c2c2'}}>Price</h4>
                                        <p style={{fontSize: '14px', color: '#000'}}>Price: <strong>{data?.price}</strong></p>
                                        <p style={{fontSize: '14px', color: '#000'}}>Currency: <strong>{data?.currency}</strong></p>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={24}>&nbsp;</Col>
                        
                        <Col xs={24}>
                            <h4 style={{fontWeight: 'bold', fontSize: '16px'}}>Thumbnail:</h4>
                            <Row gutter={16}>
                                <Col xs={8} style={{textAlign: 'center',}}>
                                    {data?.thumbnail ?
                                        <img  width="125px" height="125px" src={`${process.env.REACT_APP_API_BASE_URL}/files/${data.thumbnail}`} alt="Product Thumbnail" />
                                        :
                                        <img  width="125px" height="125px" src="demo.jpg" alt="Product Thumbnail" />
                                    }
                                </Col>
                                
                                <Col xs={0} sm={2} ></Col>
                                <Col xs={8} >
                                        <p>Image size 125x125</p>
                                        <Button type="primary" onClick={() => setisThumbVisible(true)}>Change</Button>
                                    
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col xs={0} sm={2}></Col>

            </Row>
        {/* <h2>Product Information</h2>
        <Descriptions>
          <Descriptions.Item label="Name"><strong>{data?.name}</strong></Descriptions.Item>
          <Descriptions.Item label="Weight"><strong>{data?.weight}</strong></Descriptions.Item>
          <Descriptions.Item label="Weight unit"><strong>{data?.weight_unit}</strong></Descriptions.Item>
          <Descriptions.Item label="Price"><strong>{data?.price}</strong></Descriptions.Item>
          <Descriptions.Item label="Currency"><strong>{data?.currency}</strong></Descriptions.Item>
          <Descriptions.Item label="Duribility"><strong>{data?.life_time}</strong></Descriptions.Item>
          <Descriptions.Item label="Description"><strong>{data?.description}</strong></Descriptions.Item>
         </Descriptions>
        <br />
        <br />
       <Row style={{display: 'flex', justifyContent:'center'}}>
           <Col xs={24} style={{alignSelf: 'center'}}>
               <h3 style={{textAlign: 'center'}}>Product Image</h3>
           </Col>

           <Col xs={0} md={6} style={{alignSelf: 'center'}}></Col>
           
           <Col xs={24} md={6}  style={{alignSelf: 'center'}}>
               <p>Image</p>
                {data.image ? 
                <img width="100px" height="100px" src={`${process.env.REACT_APP_API_BASE_URL}/files/${data.image}`} alt="" />
                :
                <img width="100px" height="100px" src='demo.jpg' alt="" />
                }
                
                <br />
                <br />
                <Button type="primary" onClick={()=> setIsImageModalVisible(true)}>Change</Button>
            </Col>

            
           <Col xs={24} md={6} style={{alignSelf: 'center'}}>
               <p>Thumbnail</p>
                <img width="100px" height="100px" src={`${process.env.REACT_APP_API_BASE_URL}/files/${data.thumbnail}`} alt="" />
                <br />
                <br />
                <Button type="primary" onClick={() => setisThumbVisible(true)}>Change</Button>
            </Col>
            
           <Col xs={0} md={6} style={{alignSelf: 'center'}}></Col>
       </Row> */}
       
       </div>
       
      <Modal okButtonProps={{ style: { display: 'none' } }} okText="Close" width="70%" title="Update product image" visible={isImageModalVisible} onCancel={()=>setIsImageModalVisible(false)}>
          <UpdateImage  type="product-image" close={() => setIsImageModalVisible(false)} id={data.product_id}  fnc={handleRefresh} />
      </Modal>
       
      <Modal okButtonProps={{ style: { display: 'none' } }} okText="Close" width="70%" title="Update thumbnail" visible={isThumbVisible} onCancel={()=>setisThumbVisible(false)}>
          <UpdateImage type="product-thumbnail" close={() => setisThumbVisible(false)} id={data.product_id}  fnc={handleRefresh} />
      </Modal>
        </Container>
     );
}
 
export default connect(null, {getProductDetails,updateProductAuth})(ProductDetails);